var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.40744 3.33761C8.11119 2.62886 7.33869 2.25386 6.60369 2.45261L6.39744 2.50886C3.97494 3.16886 1.90494 5.51636 2.50869 8.37386C3.89994 14.9364 9.06369 20.1001 15.6262 21.4914C18.4874 22.0989 20.8312 20.0251 21.4912 17.6026L21.5474 17.3964C21.7499 16.6576 21.3712 15.8851 20.6662 15.5926L17.0174 14.0739C16.3987 13.8151 15.6824 13.9951 15.2549 14.5164L13.8074 16.2864C11.1712 14.9776 9.04869 12.7876 7.82994 10.0989L9.48744 8.74886C10.0087 8.32511 10.1849 7.60886 9.92994 6.98636L8.40744 3.33761Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.67db07ef21e94b47648bd640743a98d3.svg";
export { ForwardRef as ReactComponent };